import makeStyles from "@material-ui/core/styles/makeStyles";
import useTheme from "@material-ui/core/styles/useTheme";
import withStyles from "@material-ui/core/styles/withStyles";
import withTheme from "@material-ui/core/styles/withTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default {
  makeStyles,
  useTheme,
  withStyles,
  withTheme,
  useMediaQuery,
};
